import { atsRequest } from "../../configs/axios.config";

class ApplicantSourcesService {
  allSources(success,error) {
    return atsRequest
      .get('/api/v1/applicant_sources')
      .then(({data}) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  createNewSource(data,success,error) {
    return atsRequest
      .post('/api/v1/applicant_sources',data)
      .then(({data}) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  editSource(data,success,error) {
    return atsRequest
      .put(`/api/v1/applicant_sources/${data.id}`,data)
      .then(({data}) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  deleteSource(data,success,error) {
    return atsRequest
      .delete(`/api/v1/applicant_sources/${data}`)
      .then(({data}) => success(data))
      .catch((errorResp) => error(errorResp));
  }
}

export const applicantSourcesService = new ApplicantSourcesService()